import { useHistory } from 'react-router';
import OAuthClient from '../AuthProvider/OAuthClient';
import { ROUTES } from '../../router/routes';

const useAuthLocation = () => {
  const history = useHistory();
  const userLogin = () => {
    if (OAuthClient.isAuthenticated()) {
      OAuthClient.logout();
      history.push(ROUTES.DASHBOARD);
    } else {
      OAuthClient.getLoginInProgress();
    }
  };

  const userLogout = () => {
    OAuthClient.logout();
  };

  return {
    userLogin,
    userLogout,
  };
};

export { useAuthLocation };
